export default __webpack_public_path__ + "static/media/tennis-icon.52412a28.svg";